import React from "react";
import Header from "../Comman/Header";
import Footer from "../Comman/Footer";
import Frequently from "./Frequently";
import AboutNFTs from "./AboutNFTs";
import WalletConnection from "./WalletConnection";
import AboutIsland from "./AboutIsland";
import AboutFestival from "./AboutFestival";
import FutureUtility from "./FutureUtility";
import GettingStarted from "./GettingStarted";

export default function FAQ() {
  return (
    <>
      <Header />
      <Frequently />
      <AboutNFTs />
      <WalletConnection />
      <AboutIsland />
      <AboutFestival />
      <FutureUtility />
      <GettingStarted />
      <Footer />
    </>
  );
}
